import { queryOptions, useQuery } from '@tanstack/react-query'

import { alertKeys } from '@/features/alerts/api/keys'
import { alertsService } from '@/features/alerts/api/alertsService'
import type { Alert, AlertTab } from '@/schemas/alerts'

/** One tab of the member's alerts: the Alerts route's MAIN data, awaited by its loader. */
export const alertsQueryOptions = (tab: AlertTab) =>
  queryOptions<Alert[]>({
    queryKey: alertKeys.list(tab),
    queryFn: () => alertsService.list(tab),
  })

/** The sidebar's ALERTS group and the fired-alert notifier read this, each on a fixed tab. */
export const useAlerts = (tab: AlertTab) => useQuery(alertsQueryOptions(tab))
